import $ from 'jquery';
import axios from 'axios';

export function getIntialServiceAgreementState() {
    const reqUrl = '/pro/apps/service_agreements_status';
    const reqHeaders = {"X-CSRF-Token": $('meta[name="csrf-token"]').attr('content')};

    return axios({
        url: reqUrl,
        method: 'GET',
        headers: reqHeaders
    })
}

export function toggleServiceAgreements(enabled){
    const reqUrl = '/pro/apps/toggle_service_agreements/' + enabled;
    const reqHeaders = {"X-CSRF-Token": $('meta[name="csrf-token"]').attr('content')};

    return axios({
        url: reqUrl,
        method: 'POST',
        headers: reqHeaders
    })
}